import React, { useState, useContext, useEffect, Fragment } from 'react';
import "../styles/registerPatient.css";
import patientModel from "../model/patient_model";
import { IonCardContent, IonButton, IonTitle } from "@ionic/react";
import AppContext from "./AppContext";
import { handleRegisterUser, getFilteredUsers, getAllSites, getUserInfoByName } from "../service/adminUI";
import registerUserModel from "../model/registerUserModel";
import { getPattern, mapFormDataWithModel } from "../util/dynamicForm";
import * as _ from "lodash";
import { updateUserModel } from '../model/registerUserModel';
import SessionManager from '../service/SessionManager';
import { sendNotificationEmail } from '../service/notificationService';

let uniqueKey = 'email';
let userid = '';

const RegisterPatient = props => {
    const { bckimgChange, setRegisterToast} = props;
    const TOAST_ERROR_CSS = 'toast toast-error';
    const TOAST_SUCCESS_CSS = 'toast toast-success';
    const { appData, userData, dtalService } = useContext(AppContext);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [patientVal, setPatientVal] = useState([]);
    const [registerRequest, setRegisterRequest] = useState('');
    const [cancelRequest, setCancelRequest] = useState('');
    const [isVisible, setIsVisible] = useState(false);
    const [registerLabel, setRegisterLabel] = useState("Register");
    const [patientSiteOptions, setPatientSiteOptions] = useState([]);
    const [patientSelectedSite, setPatientSelectedSite] = useState('');

    // Subject creation popup state
    const [showSubjectModal, setShowSubjectModal] = useState(false);
    const [subjectMode, setSubjectMode] = useState('');
    const [subjectId, setSubjectId] = useState('');
    const [siteId, setSiteId] = useState('');
    const [dob, setDob] = useState('');
    const [clinicianEmailId, setClinicianEmailId] = useState('');
    const [gender, setGender] = useState('Male');
    const [eligibility, setEligibility] = useState('Yes');

    const patient = [];

    useEffect(() => {
        bckimgChange('registerPatient.png');
        setPatientVal(patient);
        (async () => {
            try {
                const sites = await getAllSites(SessionManager.getAccessToken());
                setPatientSiteOptions(sites || []);
            } catch (err) {
                console.warn('Failed to load sites:', err);
            }
        })();
    }, []);

    useEffect(() => {
        if (registerRequest) {
           handleRegisterRequest();
        }
        if (cancelRequest) {
            clearForm();
            setCancelRequest(false)
        }
    }, [registerRequest, cancelRequest]);

    const handleRegisterRequest = async () => {
        const toastParams = await handleRegisterPatientOnClick();
        if (toastParams) {
            setRegisterToast(toastParams);
        }
        setRegisterRequest(false)
    }

    const handlerCancelFormOnClick = () => {
        setCancelRequest(true);
    }

    const handleRegisterOnClick = () => {
        setRegisterRequest(true);
    }


    const handleEyeIconOnClick = () => {
        setPasswordVisible(!passwordVisible);
    };

    const displayError = (id) => {
        const el = document.getElementById(id);
        if (el) el.style.cssText = "display: block; color: red; font-family: PoppinsRegular; font-size: 0.8rem";
    }

    const hideError = (id) => {
        const el = document.getElementById(id);
        if (el) el.style.cssText = "display: none";
    }

    const validatePatientData = () => {
        let validationResult = true;
        const patientData = [...patientVal];
        for (let i = 0; i < patientData.length; i++) {
            if (patientData[i].pattern === "password") {
                if (patientData[i].value) {
                    patientData[i].isValid = true;
                    hideError(patientData[i].key);
                } else {
                    patientData[i].isValid = false;
                    validationResult = false;
                    displayError(patientData[i].key);
                }
            } else if (patientData[i].pattern === "array") {
                if (patientData[i].value && patientData[i].value.length > 0) {
                    patientData[i].isValid = true;
                    hideError(patientData[i].key);
                } else {
                    patientData[i].isValid = false;
                    validationResult = false;
                    displayError(patientData[i].key);
                }
            } else {
                if (patientData[i].value && patientData[i].value.match(patientData[i].pattern)) {
                    patientData[i].isValid = true;
                    hideError(patientData[i].key);
                } else {
                    patientData[i].isValid = false;
                    validationResult = false;
                    displayError(patientData[i].key);
                }
            }
        }
        setPatientVal(patientData);
        return validationResult;
    }

    const validateExistingPatientData = () => {
        let validationResult = true;
        const patientData = [...patientVal];
        for (let i = 0; i < patientData.length; i++) {
            //iterate through inputs that are set
            if (patientData[i].value !== '') {
                // FIX(TC-WEB-ADMIN-003): handle password pattern — accept any
                // non-empty value (same logic as validatePatientData).
                if (patientData[i].pattern === "password") {
                    patientData[i].isValid = true;
                    hideError(patientData[i].key);
                } else if (patientData[i].pattern === "array") {
                    if (patientData[i].value && patientData[i].value.length > 0) {
                        patientData[i].isValid = true;
                        hideError(patientData[i].key);
                    } else {
                        patientData[i].isValid = false;
                        validationResult = false;
                        displayError(patientData[i].key);
                    }
                } else {
                    if (patientData[i].value && patientData[i].value.match(patientData[i].pattern)) {
                        patientData[i].isValid = true;
                        hideError(patientData[i].key);
                    } else {
                        patientData[i].isValid = false;
                        validationResult = false;
                        displayError(patientData[i].key);
                    }
                }
            }
        }
        setPatientVal(patientData);
        return validationResult;
    }
    //register device
    const handleRegisterPatientOnClick = async () => {
        userid = '';

        let auniqueObj = _.filter(patientVal, function (o) { return o.key === uniqueKey });
        let uniqueObj = !_.isEmpty(auniqueObj) ? auniqueObj[0] : null;
        if (!_.isEmpty(uniqueObj) && uniqueObj?.value !== '' && uniqueObj.value.match(uniqueObj?.pattern)) {
            //fetch the entity
            let entityVal = await getFilteredUsers(SessionManager.getAccessToken(), uniqueObj?.value);
            if (!_.isEmpty(entityVal) && entityVal[0]?.attributes && entityVal[0]?.attributes.type && entityVal[0]?.attributes.type[0] === 'patient') {
                userid = entityVal[0].id;
            }
        }

        if (!patientSelectedSite) {
            return { css: TOAST_ERROR_CSS, message: "Please select a Site" };
        }

        if (userid !== '') {
            // FIX(TC-WEB-ADMIN-003): use validateExistingPatientData for updates —
            // password is not returned by Keycloak on lookup, so it should be
            // optional when updating an existing patient.
            if (validateExistingPatientData()) {
                const finalModel = mapFormDataWithModel(updateUserModel, patientVal, 'patient');
                finalModel.attributes.sites = [patientSelectedSite];
                const result = await handleRegisterUser(finalModel.attributes.type, finalModel, SessionManager.getAccessToken(), userid);
                if (result === true) {
                    clearForm();
                    openSubjectModal();
                    return { css: TOAST_SUCCESS_CSS, message: "Patient registration succeeded!" };
                } else {
                    return { css: TOAST_ERROR_CSS, message: "Error: " + result };
                }

            }
        } else {
            if (validatePatientData()) {
                const finalModel = mapFormDataWithModel(registerUserModel, patientVal, 'patient');
                finalModel.attributes.sites = [patientSelectedSite];
                const result = await handleRegisterUser(finalModel.attributes.type, finalModel, SessionManager.getAccessToken());
                if (result === true) {
                    sendNotificationEmail({
                        type: 'user_registered',
                        to: finalModel.email,
                        payload: {
                            fullName: [finalModel.firstName, finalModel.lastName].filter(Boolean).join(' '),
                            role: 'patient',
                        },
                    });
                    clearForm();
                    openSubjectModal();
                    return { css: TOAST_SUCCESS_CSS, message: "Patient registration succeeded!" };
                } else {
                    return { css: TOAST_ERROR_CSS, message: "Error: " + result };
                }

            }
        }
    }


    const handleOnInput = async (event) => {
        let value = event.target.value;
        const name = event.target.name;
        const patientData = [...patientVal];
        for (let i = 0; i < patientData.length; i++) {
            if (patientData[i].key === name) {
                if (patientData[i].pattern === 'array') {
                    value = value.split('\n');
                }
                patientData[i].value = value;
            }
        }

        if (name === uniqueKey && value !== '') {
            let auniqueObj = _.filter(patientData, function (o) { return o.key === uniqueKey });
            let uniqueObj = !_.isEmpty(auniqueObj) ? auniqueObj[0] : null;
            if (!_.isEmpty(uniqueObj) && uniqueObj?.value !== '' && uniqueObj.value.match(uniqueObj?.pattern)) {
                //fetch the entity
                let entityVal = await getFilteredUsers(SessionManager.getAccessToken(), uniqueObj?.value);
                if (!_.isEmpty(entityVal) && entityVal[0]?.attributes && entityVal[0]?.attributes.type && entityVal[0]?.attributes.type[0] === 'patient') {
                    setRegisterLabel("Update");
                    setRegisterToast({css: TOAST_SUCCESS_CSS,message: "Found a Patient with email " + uniqueObj.value })

                    let username = { firstName: '0', lastName: '0', email: '0' };
                    for (var element in username) {
                        let idx = _.findIndex(patientData, function (o) { return o.key === element; });
                        if (idx !== -1) {
                            patientData[idx].value = entityVal[0][element];
                        }
                    }
                    element = 'phone';
                    let idx = _.findIndex(patientData, function (o) { return o.key === element; });
                    if (idx !== -1) {
                        patientData[idx].value = entityVal[0].attributes[element][0];
                    }
                    element = 'address'
                    idx = _.findIndex(patientData, function (o) { return o.key === 'address'; });
                    if (idx !== -1) {
                        patientData[idx].value = entityVal[0].attributes[element];
                    }
                    // Pre-populate site dropdown from existing user attributes
                    const existingSites = entityVal[0].attributes?.sites;
                    if (existingSites && existingSites.length > 0) {
                        setPatientSelectedSite(existingSites[0]);
                    }
                }else {
                    setRegisterLabel("Register");
                }

            }




        }
        setPatientVal(patientData);
    };

    const openSubjectModal = () => {
        setSubjectMode('');
        setSubjectId('');
        // Pre-fill siteId from the site selected on the Patient Form (read-only in popup)
        setSiteId(patientSelectedSite || userData.activeSiteId || '');
        setDob('');
        setClinicianEmailId('');
        setGender('Male');
        setEligibility('Yes');
        setShowSubjectModal(true);
    };

    const saveSubject = async () => {
        if (!subjectId.trim()) { alert("Subject ID is required"); return; }
        if (!siteId.trim()) { alert("Site ID is required"); return; }
        const payload = {
            attributes: { patientId: subjectId, siteId, clinicianEmailId, dob, gender, eligibility }
        };
        const accessRights = {
            policyowner: { userId: userData.userId, emailId: userData.emailId, type: userData.userType },
            rwowners: [{ userId: userData.userId, emailId: userData.emailId, type: userData.userType }],
            ronlyowners: []
        };
        if (clinicianEmailId) {
            try {
                const clinicianInfo = await getUserInfoByName(SessionManager.getAccessToken(), clinicianEmailId);
                if (clinicianInfo) {
                    accessRights.ronlyowners.push({ userId: clinicianInfo.id, emailId: clinicianEmailId, type: 'clinician' });
                }
            } catch (err) {
                console.warn('Could not find clinician:', err);
            }
        }
        try {
            await dtalService.create(`eCRF_subjects:${subjectId}`, payload, accessRights);
            setShowSubjectModal(false);
            setRegisterToast({ css: TOAST_SUCCESS_CSS, message: `Subject ${subjectId} created successfully` });
        } catch (err) {
            setRegisterToast({ css: TOAST_ERROR_CSS, message: `Subject creation failed: ${err.message}` });
        }
    };

    const clearForm = () => {
        document.getElementById('patient-form').reset();
        document.getElementsByTagName('textarea')[0].value = '';
        setPatientVal(patient);
        setPatientSelectedSite('');
        for (let val in patientVal) {
            hideError(patientVal[val].key);
        }
    }

    return (
      <Fragment>
        <IonTitle className="patient-title">
          Patient Form
          <span
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
            className="info-icon"
          >
            &#128712;
          </span>
          {isVisible && (
            <div className="tooltip">
               Form to Register new Patient. To update existing patient
              information, enter email of the patient to be updated.
            </div>
          )}
        </IonTitle>
        <IonCardContent className="patient-content">
          <form id="patient-form" className="patient-form">
            {Object.entries(patientModel).map((data) => {
              let idx = _.findIndex(patientVal, function (o) {
                return o.key === data[0];
              });
              return getPattern(
                data[0],
                data[1],
                1,
                handleOnInput,
                patient,
                passwordVisible,
                handleEyeIconOnClick,
                idx !== -1 ? patientVal[idx].value : patientVal
              );
            })}
            <div style={{ marginLeft: '1rem', marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label style={{ fontFamily: 'PoppinsRegular', fontSize: '14px', minWidth: '100px' }}>Site :</label>
              <select
                value={patientSelectedSite}
                onChange={e => setPatientSelectedSite(e.target.value)}
                style={{ flex: 1, padding: '8px', fontFamily: 'PoppinsRegular', fontSize: '14px' }}
              >
                <option value="">Select Site</option>
                {patientSiteOptions.map(s => (
                  <option key={s.attributes?.siteId} value={s.attributes?.siteId}>
                    {s.attributes?.name || `Site ${s.attributes?.siteId}`}
                  </option>
                ))}
              </select>
            </div>
          </form>
        </IonCardContent>
        <div className="homeMainFooter">
          <IonButton
            class="loginButton"
            fill="solid"
            shape="round"
            onClick={handlerCancelFormOnClick}
          >
            Cancel
          </IonButton>
          <IonButton
            class="loginButton"
            fill="solid"
            shape="round"
            onClick={handleRegisterOnClick}
          >
            {registerLabel}
          </IonButton>
        </div>

        {/* Subject creation/selection popup */}
        {showSubjectModal && (
          <div style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)", zIndex: 99,
            display: "flex", alignItems: "center", justifyContent: "center"
          }}>
            <div style={{
              width: "700px", maxHeight: "80vh", background: "#E6E6E6",
              border: "1px solid black", borderRadius: "8px", overflow: "auto"
            }}>
              {/* Header */}
              <div style={{
                width: "100%", height: "60px", background: "#4D4D4D",
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "0 20px", borderRadius: "8px 8px 0 0"
              }}>
                <div style={{ color: "#E6E6E6", fontFamily: "PoppinsRegular", fontSize: "16px" }}>SUBJECT INFORMATION</div>
                <div onClick={() => setShowSubjectModal(false)}
                  style={{ cursor: "pointer", color: "#E6E6E6", fontSize: "24px" }}>&times;</div>
              </div>

              {/* Mode selection */}
              {subjectMode === '' && (
                <div style={{ padding: "40px", textAlign: "center" }}>
                  <p style={{ fontFamily: "PoppinsRegular", marginBottom: "30px" }}>
                    Would you like to create a new subject or use an existing one?
                  </p>
                  <IonButton class="loginButton" fill="solid" shape="round"
                    onClick={() => setSubjectMode('create')} style={{ marginRight: "10px" }}>
                    Create New Subject
                  </IonButton>
                  <IonButton class="loginButton" fill="solid" shape="round"
                    onClick={() => setShowSubjectModal(false)}>
                    Use Existing Subject
                  </IonButton>
                </div>
              )}

              {/* Create new subject form */}
              {subjectMode === 'create' && (
                <div style={{ padding: "20px" }}>
                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontFamily: "PoppinsRegular", fontSize: "13px" }}>Subject ID *</label>
                    <input className="field-input" value={subjectId}
                      onChange={e => setSubjectId(e.target.value)} placeholder="e.g. Subject101" />
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontFamily: "PoppinsRegular", fontSize: "13px" }}>Site ID *</label>
                    <input className="field-input" value={siteId} readOnly disabled
                      style={{ backgroundColor: "#f0f0f0" }} />
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontFamily: "PoppinsRegular", fontSize: "13px" }}>Date of Birth</label>
                    <input type="date" className="field-input" value={dob}
                      onChange={e => setDob(e.target.value)} />
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontFamily: "PoppinsRegular", fontSize: "13px" }}>Clinician Email</label>
                    <input className="field-input" value={clinicianEmailId}
                      onChange={e => setClinicianEmailId(e.target.value)} placeholder="clinician@example.com" />
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontFamily: "PoppinsRegular", fontSize: "13px", marginRight: "15px" }}>Sex:</label>
                    <label><input type="radio" name="gender" value="Male" checked={gender === 'Male'}
                      onChange={e => setGender(e.target.value)} /> Male</label>
                    <label style={{ marginLeft: "15px" }}><input type="radio" name="gender" value="Female"
                      checked={gender === 'Female'} onChange={e => setGender(e.target.value)} /> Female</label>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontFamily: "PoppinsRegular", fontSize: "13px", marginRight: "15px" }}>18 or Older:</label>
                    <label><input type="radio" name="eligibility" value="Yes" checked={eligibility === 'Yes'}
                      onChange={e => setEligibility(e.target.value)} /> Yes</label>
                    <label style={{ marginLeft: "15px" }}><input type="radio" name="eligibility" value="No"
                      checked={eligibility === 'No'} onChange={e => setEligibility(e.target.value)} /> No</label>
                  </div>
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <IonButton class="loginButton" fill="solid" shape="round" onClick={saveSubject}>
                      Create Subject
                    </IonButton>
                    <IonButton class="loginButton" fill="outline" shape="round"
                      onClick={() => setSubjectMode('')} style={{ marginLeft: "10px" }}>
                      Back
                    </IonButton>
                  </div>
                </div>
              )}

            </div>
          </div>
        )}
      </Fragment>
    );
};
export default RegisterPatient;